export default __webpack_public_path__ + "static/AaronDix-55d00952bdd5f27f294505417aea5621.png";